var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-row",
        { staticClass: "pt-30 bg-white" },
        [
          _c(
            "el-col",
            { attrs: { span: 16 } },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": "180px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "二维码SN：" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: true },
                        model: {
                          value: _vm.form.code_sn,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "code_sn", $$v)
                          },
                          expression: "form.code_sn",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "设备SN：" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.device_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "device_id", $$v)
                          },
                          expression: "form.device_id",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "代理ID：" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.agent_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "agent_id", $$v)
                          },
                          expression: "form.agent_id",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否分配：" } },
                    [
                      _c("el-checkbox", {
                        attrs: { "true-label": 1, "false-label": 0 },
                        model: {
                          value: _vm.form.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "status", $$v)
                          },
                          expression: "form.status",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSubmit },
                        },
                        [_vm._v("提交")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }